import React, { FC, KeyboardEvent, useContext } from 'react';
import styled from 'styled-components';
import Icon from '@minecraft.icon';
import Input from '@minecraft.input';
import SearchWithDropdownContext from '../SearchWithDropdownContext';

const StyledInput = styled(Input)`
  padding-right: 2.25rem;
  border-radius: 0 4px 4px 0;
  border-left: none;
  height: 2rem;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 0.625rem;
  height: 0.9375rem;
  width: 0.9375rem;
  transform: translateY(-50%);
`;

const Search = styled.div`
  position: relative;
  width: 100%;
`;

type Props = {
  placeholder?: string;
  ['aria-label']?: string;
};

const SearchInput: FC<Props> = ({ placeholder, 'aria-label': ariaLabel }) => {
  const { inputValue, setInputValue, onChange, selectedOptions, onEnterClick } = useContext(SearchWithDropdownContext);

  return (
    <Search>
      <StyledInput
        name="search"
        data-qa-id="search-with-dropdown-input"
        data-testid="search-with-dropdown-input"
        aria-label={ariaLabel}
        placeholder={placeholder}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange({
            options: selectedOptions,
            inputValue: e.target.value,
          });
        }}
        onKeyPress={(e: KeyboardEvent): void => e.key === 'Enter' && onEnterClick && onEnterClick(e)}
        value={inputValue}
      />
      <SearchIcon name="search" />
    </Search>
  );
};

export default SearchInput;
